import { render, staticRenderFns } from "./EmptyNew.vue?vue&type=template&id=131ea4a5&scoped=true&"
import script from "./EmptyNew.vue?vue&type=script&lang=js&"
export * from "./EmptyNew.vue?vue&type=script&lang=js&"
import style0 from "./EmptyNew.vue?vue&type=style&index=0&id=131ea4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ea4a5",
  null
  
)

export default component.exports